'use client'

import { useEffect } from 'react'

import { useExperiment } from 'rvbr-www/red-testing'

import { trackEvent } from '@/utils/redtesting'

import HomeImg from '/public/images/hero-home-bg.webp'

import {
  Consultation,
  Contact,
  Help,
  Hero,
  Hiring,
  Plans,
  Solutions
} from '@/sections'

import { Banner } from '@/components'

import { Advantages, Interconnect, Prepaid } from './sections'

export default function Home() {
  const { variant } = useExperiment('hero_form_cards')

  useEffect(() => {
    trackEvent('activate', variant.experimentId, {
      type: 'activate',
      experiment: variant.experimentId,
      variant: variant.id
    })
  }, [])

  return (
    <main>
      <Banner
        isAnimated
        align="center"
        text="A Boa Vista mudou e agora é Equifax BoaVista!"
      />

      <Hero
        variant="home"
        title="Somos a Equifax BoaVista"
        subtitle="Uma empresa global que oferece dados para análise de crédito de pessoas e empresas."
        image={{
          src: HomeImg,
          alt: 'homem e mulher sorrindo enquanto olham para um notebook'
        }}
      />

      <Plans
        hasCustomButton={false}
        title={
          <>
            Escolha o melhor <b>plano para o seu négócio</b>
          </>
        }
        subtitle="Todos os planos incluem os relatórios para Pessoa Física e Jurídica, sem fidelidade."
      />

      <Solutions
        variant="home"
        tagText="Soluções"
        title={
          <>
            Nossas soluções impactam diretamente a <b>saúde do seu negócio</b>.
          </>
        }
      />

      <Hiring />
      <Advantages />
      <Consultation />
      <Interconnect />
      <Prepaid />
      <Help
        shouldRenderFilters
        title={
          <>
            Ficou com alguma dúvida? A <b>Equifax BoaVista</b> responde.
          </>
        }
      />
      <Contact />
    </main>
  )
}
